import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { html, nothing, type PropertyValues } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @element x-code-preview
 */
@customElement('x-code-preview')
export class XCodePreview extends BuchungsheldLitElement {
  @property() value = '';
  @property({ type: Boolean }) small = false;

  @state() private _isExpanded = false;

  override updated(changedProperties: PropertyValues): void {
    super.updated(changedProperties);

    requestAnimationFrame(() => {
      if (this.small && this.getBoundingClientRect().height < 100) this.small = false;
    });
  }

  override render() {
    return html`
      <x-flex
        horizontal
        w100
        ${acss({
          background: this.colors.neutral.shade(100),
          color: this.colors.neutral.shade(800),
          borderTopRightRadius: this.sizes.borderRadiusSecondary,
          borderBottomRightRadius: this.sizes.borderRadiusSecondary,
          overflow: 'hidden',
          position: 'relative',
          maxHeight: this.small && !this._isExpanded ? '100px' : '',
        })}
      >
        <div flex-none ${css({ width: '3px', background: this.colors.accent })}></div>
        <code
          flex
          ${css({
            overflow: this.small && !this._isExpanded ? 'hidden' : 'auto',
            padding: `${this.spacing.lg} ${this.spacing.md} 0`,
            minWidth: '0',
            position: 'relative',
          })}
        >
          <pre>${this.value}</pre>
          ${this.small && !this._isExpanded
            ? html`
                <x-flex
                  center
                  crossaxis-center
                  padding="sm"
                  ${css({
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: `linear-gradient(180deg, transparent 0%, ${this.colors.neutral.shade(100)} 75%)`,
                  })}
                >
                  <x-button mode="text" @click=${() => (this._isExpanded = true)}>
                    ${this._translation.translate('show_more')}
                  </x-button>
                </x-flex>
              `
            : nothing}
        </code>
        <x-button
          mode="icon"
          icon="content_copy"
          @click=${async e => {
            await navigator.clipboard.writeText(this.value);
            return XSnackbar.show(this._translation.translate('copied_to_clipboard'));
          }}
          ${css({ position: 'absolute', top: this.spacing.xs, right: this.spacing.xs })}
        >
        </x-button>
      </x-flex>
    `;
  }

  override styles() {
    return [...super.styles(), { ':host': { display: 'flex' } }];
  }
}
